import g from "./useContract.js";
import { ERROR_CODE as A } from "../../temp-lib/constants/error.js";
import { useMessageContext as M } from "../../temp-lib/contexts/share/MessageContext.js";
import { CustomError as R } from "../../temp-lib/errors/customError.js";
import _ from "../../ui-lib/components/ApeironPleaseWait.js";
import * as i from "ramda";
import { useCallback as m } from "react";
import { useTranslation as d } from "react-i18next";
import { jsx as y } from "react/jsx-runtime";
const b = (h) => {
  const {
    contractTypes: w
  } = h, {
    setInfo: u
  } = M(), {
    t: n
  } = d(), r = g(w.allowance), {
    send: c
  } = g(w.request), a = m((o) => {
    i.isNotNil(o) && u({
      message: /* @__PURE__ */ y(_, {
        subject: o
      })
    });
  }, [u]), l = m(async (o, t, e) => {
    if (e) {
      const s = await r.call(o, t);
      return BigInt(s) >= e;
    } else
      return r.call(o, t);
  }, [r]), k = m(async (o, t, e, s = null, f = {
    checkMessage: n("common.check_token_approve"),
    waitMessage: n("common.wait_token_approve")
  }) => {
    const {
      checkMessage: C,
      waitMessage: N
    } = f;
    try {
      if (a(C), !await l(o, t, e))
        if (a(N), i.isNotNil(e)) {
          if (i.isNil(s))
            throw new R("please set allowance if you want to approve erc token", A.CONTRACT.APPROVAL_FAIL);
          await c(t, s.toString());
        } else
          await c(t, !0);
      return !0;
    } catch (p) {
      throw a(null), p;
    }
  }, [l, c, a, n]);
  return {
    checkAllowed: l,
    request: k
  };
};
export {
  b as default
};
//# sourceMappingURL=useAllowance.js.map
